import { createSlice } from '@reduxjs/toolkit';
import { emit, emitMsg } from '../websocket/websocketSlice';

export const studentsSlice = createSlice({
    name: 'students',
    initialState: { students: [], noiseLevel: 0 },
    reducers: {
        init: (state, action) => {
            return { ...action.payload };
        },
        toggle: (state, action) => {
            let students = state.students.map(
                (s) => (action.payload === s.id ? { ...s, selected: !s.selected } : s)
            );
            state.students = students;
        },
        selectAll: (state, action) => {
            let students = state.students.map((s) => ({ ...s, selected: action.payload }));
            state.students = students;
        },
        behave: (state, action) => {
            let { behaviour, students } = action.payload;
            emit({ type: 'behave', behaviour, students });

            return {
                ...state,
                students: state.students.map((s) =>
                    students.includes(s.id) ? { ...s, behaviour } : s
                ),
            };
        },
        triggerBehaviour: (state, action) => {
            switch (action.payload.type) {
                case 'impulse':
                    emit({
                        type: 'impulseGiven',
                        students: state.students.filter((s) => s.selected).map((s) => s.id),
                        impulse: action.payload,
                    });

                    state.students = state.students.map((s) =>
                        s.selected ? { ...s, behaviour: action.payload, selected: false } : s
                    );
                    break;

                default:
                    emit({
                        type: 'behave',
                        students: state.students.filter((s) => s.selected).map((s) => s.id),
                        behaviour: action.payload.behaviour,
                    });
                    state.students = state.students.map((s) =>
                        s.selected ? { ...s, behaviour: action.payload.behaviour, selected: false } : s
                    );
            }
        },
        askQuestions: (state, action) => {
            let { students, questions } = action.payload;
            emit({ type: 'askQuestion', students, questions });

            state.students = state.students.map((s) =>
                s.selected ? { ...s, behaviour: 'AskQuestion', selected: false } : s
            );
        },
        syncBehaviour: (state, action) => {
            let students = state.students.map((s) =>
                s.id === action.payload.id ? { ...s, behaviour: action.payload.behaviour } : s
            );
            state.students = students;
        },
        changeNoiseLevel: (state, action) => {
            emitMsg('changeNoiseLevel', action.payload);
            state.noiseLevel = action.payload;
        },
        setVolume: (state, action) => {
            state.noiseLevel = action.payload;
        }
    },
});

export const {
    init,
    toggle,
    selectAll,
    triggerBehaviour,
    syncBehaviour,
    behave,
    changeNoiseLevel,
    setVolume,
    askQuestions,
} = studentsSlice.actions;

export const selectStudents = ({ students }) => students.students;
export const selectNoiseLevel = ({ students }) => students.noiseLevel;
export const findSelectedStudents = ({ students }) => students.students.filter((s) => s.selected);

export default studentsSlice.reducer;
